export default "__VITE_ASSET__721efb90__"